module.exports = __webpack_public_path__ + "static/media/triplets.0f2567fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile-icons/triplets.svg
// module id = 1114
// module chunks = 31